module.exports = __webpack_public_path__ + "static/media/LGSmartLight__W.dda2ac92.woff2";